/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface EmailContentRef
 */
export interface EmailContentRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentRef
   */
  contentId?: number;
}

export interface EmailContentRef extends EmailContentRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailContentRef
   */
  contentId: number;
}

export interface EmailContentRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof EmailContentRef
   */
  contentId?: number;
  contentIdIsSet: boolean;
}

transformDatesMap.set("EmailContentRef", function (model: EmailContentRef) {});

export type EmailContentRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  contentId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var EmailContentRefMeta: EmailContentRefMetaI =
  {} as EmailContentRefMetaI;
EmailContentRefMeta = typeMeta("EmailContentRef", {
  contentId: propertyMeta("contentId", false, true, true, MetaTypesBase.number),
});

const metaI = EmailContentRefMeta;

registerMeta(() => {});

export class EmailContentRefTracked implements EmailContentRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  contentId__I?: number = undefined;

  get contentIdIsSet() {
    return this.contentId !== undefined;
  }
  set contentIdIsSet(v: boolean) {}
  set contentId(v: undefined | number) {
    if (v !== undefined) {
      this.contentId__I = v;
      this.contentIdIsSet = true;
    } else {
      this.contentId__I = v || undefined;
      this.contentIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get contentId() {
    return this.contentId__I;
  }
  constructor(config?: EmailContentRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.contentIdIsSet == true && other?.contentIdIsSet == true)
      return this.contentId == other.contentId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.contentId) {
      this.contentIdIsSet = true;
    }
  }
  assignFrom(
    config: EmailContentRefOptional,
    options?: AssignOptions,
  ): EmailContentRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.contentId && this.contentIdApplyFilter(optionsRequired.filter)) {
      this.contentId = config.contentId;
      if (optionsRequired.unassign) this.contentIdIsSet = false;
      else this.contentIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailContentRefTrackedI {
    const cloned = {} as EmailContentRefTrackedI;
    if (
      this.contentIdIsSetDeep() &&
      this.contentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.contentIdIsSet = true;
      cloned.contentId = this.contentId;
    } else {
      //cloned.contentIdIsSet = false
    }
    if (!isDeleted(this) && !this.contentIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailContentRefTrackedI {
    if (!this.contentIdApplyFilter(filter)) this.contentIdIsSet = false;

    return this;
  }
  contentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailContentRefMeta.contentId,
      EmailContentRefMeta,
      this.contentId,
      this,
    );
  }
  contentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.contentIdIsSet && this.contentIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.contentIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
